import { Flex, spacing, typography, value } from '@lokalise/louis';
import { css, modifier, styled } from '@lokalise/styled';

export const SocialProofCarouselContainer = styled.div`
    width: 100%;
    overflow: hidden;
`;

export const SlideTrack = styled.div`
    display: flex;
    transform-origin: center;
    transition: all 0.4s ease-in-out;
`;

export const SlideContainer = styled(Flex)<{ $isActive: boolean }>`
    background: ${value('color.background.input.default')};
    width: 400px;
    height: 380px;
    flex: 0 0 auto;
    transition: inherit;

    padding: ${spacing(7, 5, 3)};
    border-radius: ${spacing(5)};

    opacity: 0.5;
    transform: scale(0.75);

    ${modifier(
        '$isActive',
        css`
            color: ${value('color.background.surface.inverse')};
            transform: scale(1);
            opacity: 1;
        `,
    )}
`;

export const SlideTitle = styled.h4`
    ${typography('heading.4')};
    text-align: center;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    margin-top: ${spacing(0)};

    color: ${value('color.text.default')};
`;

export const SlideDescription = styled.p`
    ${typography('body.small.default')};
    text-align: center;

    color: ${value('color.text.light.default')};
`;

export const SlideImage = styled.img`
    max-width: 320px;
`;

export const SlideTestimonial = styled.p`
    ${typography('body.action.small')};
    line-height: ${spacing(5)};
    margin-top: ${spacing(5)};
    margin-bottom: ${spacing(0)};

    color: ${value('color.text.light.default')};
`;

export const SlideCompanyLogosContainer = styled(Flex)`
    margin-top: ${spacing(1)};
    gap: ${spacing(3)};
`;

export const SlideCarouselContainer = styled.div``;

export const SlideCarouselIndicatorContainer = styled(Flex)`
    gap: ${spacing(1)};
    margin-top: ${spacing(8)};
`;

export const SlideCarouselIndicator = styled.button<{ $isActive: boolean }>`
    background-color: ${value('color.background.input.default')};
    color: ${value('color.background.surface.inverse')};
    height: ${spacing(2)};
    width: ${spacing(2)};
    border-radius: 50%;
    border: none;
    cursor: pointer;
    padding: 0;

    ${modifier(
        '$isActive',
        css`
            background-color: ${value('color.background.surface.inverse')};
            color: ${value('color.background.input.default')};
        `,
    )}
`;
